import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

const heroFormDom = document.getElementById('form-hero');

if (heroFormDom) {
  const heroRoot = createRoot(heroFormDom);
  const contentId = heroFormDom.getAttribute('data-content-id');
  const formType = heroFormDom.getAttribute('data-form-type');
  const trialType = heroFormDom.getAttribute('data-trial-type');
  const trialLength = heroFormDom.getAttribute('data-trial-length');
  const ctaButton = heroFormDom.getAttribute('data-cta-button');
  const ctaClassNameModifier = heroFormDom.getAttribute('data-hero-trial-cta-class-name-modifier');
  const trialHeroIsMaxDataAttribute = heroFormDom.getAttribute('data-max');
  const emailPlaceholder = heroFormDom.getAttribute('data-email-placeholder');
  heroRoot.render(
    <App
      hero={true}
      contentId={contentId}
      formType={formType}
      trialType={trialType}
      trialHeroIsMaxDataAttribute={trialHeroIsMaxDataAttribute === 'true'}
      trialLength={Number(trialLength)}
      ctaButton={ctaButton}
      ctaClassNameModifier={ctaClassNameModifier}
      emailPlaceholder={emailPlaceholder}
    />
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
